












































import { PartyProductModel, ApplicationUserModel } from '@/libs/Api';
import { Guid } from '@/libs/common/functions/guid';
import { Component, Vue, Prop, Ref } from 'vue-property-decorator';
import NOIFDialog from '@/libs/clients/components/NOIFDialog.vue';
import { applicationUserStore } from '@/libs/user-settings/+state/store';
import { CrudGetter } from '@/libs/core/crud/crud-getter';

@Component({
    components: {
        NOIFDialog
    }
})
export default class NOIFCard extends Vue {

    @Prop() partyProduct!: PartyProductModel;
    @Prop() clientId!: string;
    @Ref() dialog!: NOIFDialog;
    @Prop({ default: false }) accountSection!: boolean;
    
    newId: string | null = Guid.EmptyGuid();

    get user(): ApplicationUserModel {
        return applicationUserStore.useGetter(CrudGetter.Detail);
    }

    openPartyProduct() {
        this.dialog.open();
    }

}

